// extracted by mini-css-extract-plugin
export const container = "Sidebar-module--container--1maBc";
export const appear = "Sidebar-module--appear--2UnZy";
export const is_closed = "Sidebar-module--is_closed--27oah";
export const is_open = "Sidebar-module--is_open--3L8rI";